import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { refreshUserToken } from './thunks/refreshUserToken'

export type SessionState = {
  token: string | null
  accessToken: string | null
  refreshToken: string | null
  isEmailVerified: boolean
  email: string | null
  isRefreshing: boolean
  refreshError: string | null
}

export const sessionInitialState: SessionState = {
  token: null,
  accessToken: null,
  refreshToken: null,
  isEmailVerified: false,
  email: null,
  isRefreshing: false,
  refreshError: null,
}

export const sessionSlice = createSlice({
  name: 'session',
  initialState: sessionInitialState,
  reducers: {
    setUserSession: (state, action: PayloadAction<{
      token: string | null
      accessToken: string | null
      refreshToken: string | null
      isEmailVerified: boolean
      email: string | null
    }>) => {
      state.token = action.payload.token
      state.accessToken = action.payload.accessToken
      state.refreshToken = action.payload.refreshToken
      state.isEmailVerified = action.payload.isEmailVerified
      state.email = action.payload.email
      state.refreshError = null
    },
    setUserEmailVerified: (state, action: PayloadAction<boolean>) => {
      state.isEmailVerified = action.payload
    },
    clearUserSession: (state) => {
      state.token = null
      state.accessToken = null
      state.refreshToken = null
      state.isEmailVerified = false
      state.email = null
      state.isRefreshing = false
      state.refreshError = null
    },
    clearRefreshError: (state) => {
      state.refreshError = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(refreshUserToken.pending, (state) => {
        state.isRefreshing = true
        state.refreshError = null
      })
      .addCase(refreshUserToken.fulfilled, (state, action) => {
        state.isRefreshing = false
        state.accessToken = action.payload.accessToken
        state.refreshToken = action.payload.refreshToken
        state.token = action.payload.token
        state.refreshError = null
      })
      .addCase(refreshUserToken.rejected, (state, action) => {
        state.isRefreshing = false
        state.refreshError = action.payload as string
      })
  },
})

export const {
  setUserSession,
  setUserEmailVerified,
  clearUserSession,
  clearRefreshError,
} = sessionSlice.actions

export default sessionSlice.reducer